export enum StrategyDetailsTabsEnum {
  DETAILS = 'Details',
  INVESTORS = 'Investors',
  UPDATES = 'Updates',
  RESEARCH = 'Research'
}
